module.exports = __webpack_public_path__ + "assets/img/preview_03.964a8ae2.png";